import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M15 9.86v4.28L18.03 12zM6 9.86v4.28L9.03 12z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 18l8.5-6L4 6v12zm2-8.14L9.03 12 6 14.14V9.86zM21.5 12L13 6v12l8.5-6zM15 9.86L18.03 12 15 14.14V9.86z"
})), 'FastForwardTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FastForwardTwoTone.js
// module id = 3508
// module chunks = 2